/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { dayjs } from "@myenergi-ltd/utils";
import "dayjs/locale/de";
import "dayjs/locale/en";
import "dayjs/locale/en-gb";
import "dayjs/locale/en-ie";
import arraySupport from "dayjs/plugin/arraySupport";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// use plugins
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(arraySupport);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);

// NOTE: The corresponding supported locale files must be imported above.
const supportedLocales = ["en-GB", "en-IE", "de-DE", "de"];

export let selectedLocale = "en-GB";

// Define supported locale on app load

export const findSelectedLanguage = (language = navigator.language) => {
  selectedLocale = supportedLocales.includes(language) ? language : "en-GB";

  dayjs.locale(selectedLocale);
};

findSelectedLanguage();
